<!-- eslint-disable -->
<template lang="pug">
    .play-box.puzzle-playbox(v-show='!isFirstTime', :class="{'puzzle-playbox_with-loader': isLoading}")
        template(v-if='!isLoading')
            game-header(
                v-if="!isBattle",
                @soundStateChanged="headerKey = !headerKey",
                :key="headerKey",
                slug="Puzzle",
                game-type="mentalArithmetic",
                :is-homework="!!exerciseId",
            )
            .puzzle-game-wrapper(v-show='!showExample && !puzzleComplete')
                #puzzle.puzzle-game-canvas-handler
                .game-info__container(ref="info")
                    .game-info__block
                        game-info(
                            :score="{left: !isBattle ? answers.good : userScore, right: !isBattle ? answers.bad : opponentScore}"
                            :time="getTime"
                            :is-olympiad="isOlympiad"
                            :is-from-battle="isBattle",
                            :opponent="opponent",
                            :is-opponent-answering="isOpponentAnswering",
                        )
            div(
                v-if='showExample',
                :in-puzzle='true',
                :is='puzzleGame.games[0].slug',
                :exercise-id='null',
                :type='getInnerGameType',
                :place='1',
                :show-turtle='false',
                @showTurtle="$emit('showTurtle', $event)",
                @setMotion="$emit('setMotion', $event)",
                @finish='finish',
                :game-type='puzzleGame.games[0].parameters && puzzleGame.games[0].parameters.courseType',
                :answer-duration='answerDuration',
                :check-multiplayer-answers='checkMultiplayerAnswers',
                :play-again='playAgain',
                @playAgainReady="$emit('playAgainReady', $event)",
                @checkAnswersReady="$emit('checkAnswersReady', $event)"
            )
            //fireworks(v-if='puzzleComplete && !isOlympiad', :is-mobile='isMobile')
            .puzzle-playbox__result-container(v-if='puzzleComplete')
                img.puzzle-playbox__result-image(:src='puzzleGame.image')
                result-buttons(
                    :exercise-id="exerciseId"
                    games-type="mentalArithmetic"
                    show-restart-button
                    @restartGame="restartGame"
                )
                    slot
        calculating-answers(v-if="calculatingAnswers")
</template>

<script>
    /*eslint-disable*/
    const AdditionAndSubtraction = () => import('../addition-and-subtraction/PlayBox.vue');
    const AdditionAndSubtractionWithTime = () => import('../addition-and-subtraction-with-time/PlayBox.vue');
    const MultiplicationAndDivision = () => import('../multiplication-and-division/PlayBox.vue');
    const InteractiveFlashCards = () => import('../interactive-flash-cards/PlayBox.vue');
    const Equation = () => import('../equation/PlayBox.vue');
    const Anzan = () => import('../anzan/PlayBox.vue');
    const AnzanWithTime = () => import('../anzan-with-time/PlayBox.vue');
    import GameHeader from '../../GameHeader.vue';
    import RotationIcon from '../../../motivation/detective/detective-assets/RotationIcon.vue';
    import GameInfo from '../GameInfo.vue';

    import trainerConfig from '../../../../config/trainer';
    import gamesConfig from '../../../../config/games';
    import timer from '../../../../utils/trainer/timer';
    import getBase64FromUrl from '../../../../utils/getBase64FromUrl';

    import MobileDetect from 'mobile-detect/mobile-detect.js';

    import _ from 'lodash';
    import { mapState } from 'vuex';
    //import Fireworks from '../Fireworks.vue';

    import GameStatsApi from '../../../../api/games/gameStat';
    import GameExerciseApi from '../../../../api/games/gameExercise';
    import ResultButtons from '../ResultButtons.vue'
    import Battle from '../../../../utils/battle/battleMixin'
    import GameMixin from '../../../../utils/trainer/game'
    import answerDurationMixin from '../../../../utils/trainer/answerDurationMixin'
    import EndGameMixin from '../../../../utils/trainer/endGame'
    import CalculatingAnswers from "../../CalculatingAnswersModal.vue";

    const HELP_DISTANCE = 20;
    const CANVAS_MARGIN = 20;
    const ANIMATION_TIME = 700;
    const DEFAULT_VOLUME = 0.6;
    const SIDE_PADDING_SUMMARY = 80;

    //TODO: redraw puzzle on device rotation

    function DEFAULT_DATA() {
        return {
          isFirstTime: true,
          imageSize: null,
          gameImage: null,
          stage: null,
          container: null,
          frame: null,
          puzzleImage: null,
          countPlacedPieces: 0,
          countOpenedPieces: 0,
          tiles: [],
          showExample: false,
          clickedPiece: null,
          puzzleComplete: false,
          isLoading: true,
          loadedSound: 0,
          trainerConfig: _.cloneDeep(trainerConfig),
          gamesConfig: _.cloneDeep(gamesConfig),
          soundInstance: null,
          exercise: null,
          gameStat: null,
          gameEnd: false,
          answers: {
            good: 0,
            bad: 0,
          },
          multAndDivExample: null,
          headerKey: true,
          parameters: [],
          isCorrect: false,
        }
    }

    export default {
        props: {
            exerciseId: [Number, String],
            playersNumber: Number,
            showTurtle: {
                type: Boolean,
                default: true
            },
            gameType: {
                type: String,
                default: 'homework'
            },
            answerDuration: Number,
            checkMultiplayerAnswers: Boolean,
            playAgain: Boolean,
            isLastGameInBattle: {
                type: Boolean,
                default: false
            }
        },
        components: {
            ResultButtons,
            AdditionAndSubtraction,
            AdditionAndSubtractionWithTime,
            MultiplicationAndDivision,
            Equation,
            Anzan,
            AnzanWithTime,
            InteractiveFlashCards,
            RotationIcon,
            GameHeader,
            GameInfo,
            CalculatingAnswers,
            //Fireworks,
        },
        mixins: [timer, getBase64FromUrl, GameMixin, answerDurationMixin, EndGameMixin, Battle],
        beforeDestroy () {
            this.$createjs.Sound.removeAllSounds();
            this.$createjs.Sound.removeAllEventListeners();
        },
        mounted () {
            this.fetchData()
            .then(() => {
                this.registerSounds();
            })
        },
        data () {
            return DEFAULT_DATA();
        },
        methods: {
          restartGame() {
            Object.assign(this, DEFAULT_DATA());
            this.resetTimer();
            this.fetchData()
                .then(() => {
                  this.registerSounds();
                })
          },
            fetchData () {
                return new Promise((resolve, reject) => {
                    if (this.exerciseId) {
                        GameExerciseApi.show(this.exerciseId)
                        .then(data => {
                            this.assignData(data);
                            return this.assignParameters();
                        })
                        .then(stat => {
                            this.assignGameStat(stat);
                            if (this.isBattle) {
                                this.setParametersForPuzzleGame();
                            }
                            if (_.isEmpty(this.puzzleGame)) {
                                this.$router.push({
                                    name: 'browse:game',
                                    params: {
                                        exerciseId: this.exerciseId,
                                        type: 'Puzzle'
                                    }
                                });
                                return;
                            }
                            let parameters = this.puzzleGame.games[0].parameters;
                            let parametersForSet = parameters.default;
                            for (let key in parameters) {
                                if (key !== 'default' && key.match(/[\d]*[\d]+/g).some(userId => +userId === this.user.id)) {
                                    parametersForSet = parameters[key];
                                }
                            }
                            this.$store.dispatch('setParamsArray', [parametersForSet]);
                            resolve();
                        })
                        .catch(err => {
                            this.showErrorMessage(err);
                            reject();
                        });
                    } else if (!this.$offline && this.user.type === 'student') {
                        this.createStat()
                        .then(stat => {
                            this.assignGameStat(stat);
                            resolve();
                        })
                        .catch(err => {
                            this.showErrorMessage(err);
                            reject();
                        })
                    } else {
                        resolve();
                    }
                });
            },
            assignData (data) {
                let stat = _.find(data.stats, {userId: this.user.id});
                this.gameStat = stat;
                this.time = data.stats.length > 0 ?
                        stat.executionTime || 0 : 0;
                this.points = data.stats.length > 0 ?
                        stat.points || 0 : 0;
                this.exercise = data;
                this.answers.good = this.exercise.correctAnswers || 0;
                this.answers.bad = this.exercise.wrongAnswers || 0;
            },
            assignParameters () {
                if (!this.gameStat) {
                    return this.createStat();
                }
                return this.gameStat;
            },
            assignGameStat (stat) {
                stat && (this.gameStat = stat);
                if (this.gameStat.openedPuzzlePieces) {
                    this.countOpenedPieces = this.gameStat.openedPuzzlePieces;
                }
            },
            async assignPuzzleImage () {
                this.parameters.image = await this.getBase64ImageFromUrl(
                    this.$options.filters.apiFile(this.parameters.imageSrc)
                );
            },
            setParametersForPuzzleGame() {
                this.parameters = this.gameStat.parameters;
                this.assignPuzzleImage();
                this.$store.dispatch('setPuzzleGame', this.parameters);
                for (let key in this.parameters.games[0].parameters) {
                    if (key !== 'default' && key.match(/[\d]*[\d]+/g).some(userId => +userId === this.user.id)) {
                        this.$store.dispatch(
                            'setParamsArray',
                            [this.parameters.games[0].parameters[key]]
                        );
                        return;
                    }
                }
                this.$store.dispatch('setParamsArray', [this.parameters.games[0].parameters.default]);
            },
            createStat () {
                let game = this.exercise ? this.exercise.slug : 'Puzzle';
                let parameters = this.exercise ? this.exercise.parameters.default : _.cloneDeep(this.puzzleGame);
                let course = 'mental-arithmetic';
                delete parameters.image;
                let stat = {
                    game,
                    parameters,
                    course,
                    userId: this.user.id,
                    attempts: 0,
                    gameExerciseId: this.exercise && this.exercise.sourceType === 'olympiadLevelTrainerStage' ? undefined : this.exerciseId
                };
                return GameStatsApi.create(stat);
            },
            sendStat () {
                if (this.gameStat) {
                    this.refreshGameStatBeforeSend();
                    return GameStatsApi.update(this.gameStat.id, this.gameStat)
                    .then(data => {
                        this.gameStat.id = data.id;
                        this.isCorrect = false;
                    })
                    .catch(err => {
                        this.$toasted.error(this.$root.$t('errors.saving_results'));
                    });
                }
            },
            refreshGameStatBeforeSend () {
                this.gameStat.openedPuzzlePieces = this.countOpenedPieces;
                this.gameStat.attempts = this.answers.good + this.answers.bad;
                this.gameStat.answers = this.answers.good;
                this.gameStat.percent = this.calculatePercent();
                this.gameStat.isCompleted = this.gameEnd;
                this.gameStat.executionTime = this.time !== 0 ? this.time : this.timeBeforeDestroy;
                this.gameStat.example = this.getInnerGameType === 'MultiplicationAndDivision' ? this.multAndDivExample : null;
                this.gameStat.isCorrect = this.isCorrect;
                this.gameStat.isOlympiadLevelTrainer = this.isOlympiad && this.exercise && this.exercise.sourceType === "olympiadLevelTrainerStage";
                let statParams = _.cloneDeep(this.puzzleGame);
                delete statParams.image;
                this.gameStat.parameters = statParams;
            },
            calculatePercent() {
                let total = this.answers.good + this.answers.bad;
                if (total > 0) {
                    return parseInt(this.answers.good / (total) * 100);
                }
                return 0;
            },
            async start() {
                this.gameImage = this.puzzleGame.image;
                if(this.gameImage === undefined) {
                    this.gameImage = await this.getBase64ImageFromUrl(this.$options.filters.apiFile(this.puzzleGame.imageSrc));
                }
                this.imageSize = await this.getImageDimensions(this.gameImage);
                if (this.imageSize.width !== this.imageSize.height) {
                    this.gameImage = await this.cropSquareFromCenter(this.gameImage);
                    this.imageSize = await this.getImageDimensions(this.gameImage);
                }
                let minGameBoxSize = Math.min(this.gameBox.width, this.gameBox.height);
                let maxImageSize = Math.max(this.imageSize.width, this.imageSize.height);
                if (maxImageSize > minGameBoxSize) {
                    //resize image to canvas frame size
                    this.gameImage = await this.resizeBase64Image(this.gameImage, minGameBoxSize, minGameBoxSize);
                }
                this.initCanvas();
            },
            finish (answers, time, example) {
                this.isCorrect = !!answers;
                this.answers.good += answers.good;
                this.answers.bad += answers.bad;
                if (!this.isOlympiad && !this.isBattle) {
                    this.time += time;
                }
                if (example) {
                    this.multAndDivExample = example;
                }
                this.showExample = false;
                this.colorizeShape(this.clickedPiece);
                this.clickedPiece = null;
                this.countOpenedPieces++;
                this.stage.update();
                this.sendStat();
            },
            cropSquareFromCenter(base64data) {
                return new Promise((resolve,reject) => {
                    let cropSize = Math.max(this.imageSize.width, this.imageSize.height);
                    let imageWidth = this.imageSize.width;
                    let imageHeight = this.imageSize.height;
                    // We create an image to receive the Data URI
                    let img = document.createElement('img');
                    img.crossOrigin = "anonymous";
                    // When the event "onload" is triggered we can resize the image.
                    img.onload = function() {
                        // We create a canvas and get its context.
                        let canvas = document.createElement('canvas');
                        let ctx = canvas.getContext('2d');
                        // We set the dimensions at the wanted size.
                        canvas.width = cropSize;
                        canvas.height = cropSize;

                        ctx.fillStyle = "white";
                        ctx.fillRect(0, 0, canvas.width, canvas.height);
                        // We resize the image with the canvas method drawImage();
                        //ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);
                        ctx.drawImage(this, (imageWidth - cropSize) / 2, (imageHeight - cropSize) / 2, cropSize, cropSize, 0, 0, cropSize, cropSize);
                        resolve(canvas.toDataURL());
                    };
                    // We put the Data URI in the image'shape src attribute
                    img.src = base64data;

                })
            },
            resizeBase64Image(base64data, wantedWidth, wantedHeight) {
                return new Promise((resolve,reject) => {
                    // We create an image to receive the Data URI
                    let img = document.createElement('img');
                    // When the event "onload" is triggered we can resize the image.
                    img.onload = function() {
                        // We create a canvas and get its context.
                        let canvas = document.createElement('canvas');
                        let ctx = canvas.getContext('2d');
                        // We set the dimensions at the wanted size.
                        canvas.width = wantedWidth;
                        canvas.height = wantedHeight;
                        // We resize the image with the canvas method drawImage();
                        ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);
                        resolve(canvas.toDataURL());
                    };
                    // We put the Data URI in the image'shape src attribute
                    img.src = base64data;

                })
            },
            getImageDimensions(base64Data) {
                return new Promise ((resolve, reject) => {
                    let i = new Image();
                    i.onload = function(){
                        resolve({width: i.width, height: i.height})
                    };
                    i.src = base64Data
                })
            },
            createImageFromBase64() {
                return new Promise((resolve => {
                    Bitmap.fromData(this.gameImage, (bitmap) => {
                        resolve(bitmap);
                    })
                }))
            },
            initCanvas() {
                this.frame = new Frame("puzzle", this.gameBox.width, this.gameBox.height);
                this.frame.on("ready", () => {
                    this.stage = this.frame.stage;
                    this.container = new Container();
                    this.createImageFromBase64().then((imageObj) => {
                        this.puzzleImage = imageObj;
                        this.puzzleImage.alpha = 0.0;
                        this.draw();
                        this.soundInstance = this.$createjs.Sound.play("puzzleShake");
                        this.soundInstance.volume = DEFAULT_VOLUME;
                    });
                    this.container.addTo(this.stage);
                    this.stage.update();
                });
            },
            draw() {
                let numOfDrawingPiece = 1;
                this.puzzleImage.pos(this.puzzleX,this.puzzleY);
                this.prepareTiles();
                for (let j = 0; j < this.verticalPieces; j++) {
                    for (let i = 0; i < this.horizontalPieces; i++) {
                        this.drawPuzzle(i, j, numOfDrawingPiece <= this.countOpenedPieces);
                        numOfDrawingPiece++;
                    }
                }
            },
            prepareTiles() {
                let tempTileArray = [];
                for (let j = 0; j < this.verticalPieces; j++) {
                    tempTileArray[j] = [];
                    for (let i = 0; i < this.horizontalPieces; i++) {
                        tempTileArray[j][i] = new Object();
                        tempTileArray[j][i].right = Math.floor(Math.random() * 2);
                        tempTileArray[j][i].down = Math.floor(Math.random() * 2);

                        if (j > 0) {
                            tempTileArray[j][i].up = 1 - tempTileArray[j - 1][i].down;
                        }
                        if (i > 0) {
                            tempTileArray[j][i].left = 1 - tempTileArray[j][i - 1].right;
                        }
                    }
                }
                this.tiles = tempTileArray;
            },
            createShape(visible) {
                let shape = new Shape();
                shape.drag();
                shape.mouseChildren = false;
                shape.visible = visible;
                shape.addTo(this.container);
                return shape;
            },
            drawPuzzle(i, j, drawColored) {
                let offsetX = this.pieceWidth * i;
                let offsetY = this.pieceHeight * j;
                let shape = this.createShape(drawColored);
                shape.addEventListener("pressup", this.dragHandler);
                shape.alpha = drawColored ? 1 : 0;
                this.drawPuzzleShape(shape.graphics, offsetX, offsetY, i ,j, true);
                this.drawHint(shape, shape.graphics);
                if (shape.alpha && shape.visible) {
                    shape.animate({
                        obj: {
                            x:rand(-offsetX,this.frame.width-offsetX-this.pieceWidth),
                            y:rand(-offsetY,this.frame.height-offsetY-this.pieceHeight)
                        },
                        time: ANIMATION_TIME
                    });
                } else {
                    let whiteShape = this.createShape(true);
                    this.drawPuzzleShape(whiteShape.graphics, offsetX, offsetY, i ,j, false);
                    whiteShape.coloredShape = shape;
                    whiteShape.addEventListener("click", this.whiteShapeClickHandler);
                    whiteShape.animate({
                        obj: {
                            x:rand(-offsetX,this.frame.width-offsetX-this.pieceWidth),
                            y:rand(-offsetY,this.frame.height-offsetY-this.pieceHeight)
                        },
                        time: ANIMATION_TIME
                    });
                }
            },
            drawPuzzleShape(context, offsetX, offsetY, i, j, colored) {
                let tileObj = this.tiles[j][i];
                let x8 = Math.round(this.pieceWidth / 8);
                let y8 = Math.round(this.pieceHeight / 8);
                context.setStrokeStyle(3,"round");
                context.beginStroke(createjs.Graphics.getRGB(0, 0, 0));
                if (colored) {
                    context.beginBitmapFill(this.puzzleImage.image);
                } else {
                    context.beginFill("white");
                }
                context.moveTo(offsetX, offsetY);

                if (j != 0) {
                    context.lineTo(offsetX + 3 * x8, offsetY);
                    if (tileObj.up == 1) {
                        context.curveTo(offsetX + 2 * x8, offsetY - 2 * y8, offsetX + 4 * x8, offsetY - 2 * y8);
                        context.curveTo(offsetX + 6 * x8, offsetY - 2 * y8, offsetX + 5 * x8, offsetY);
                    } else {
                        context.curveTo(offsetX + 2 * x8, offsetY + 2 * y8, offsetX + 4 * x8, offsetY + 2 * y8);
                        context.curveTo(offsetX + 6 * x8, offsetY + 2 * y8, offsetX + 5 * x8, offsetY);
                    }
                }
                context.lineTo(offsetX + 8 * x8, offsetY);
                if (i != this.horizontalPieces - 1) {
                    context.lineTo(offsetX + 8 * x8, offsetY + 3 * y8);
                    if (tileObj.right == 1) {
                        context.curveTo(offsetX + 10 * x8, offsetY + 2 * y8, offsetX + 10 * x8, offsetY + 4 * y8);
                        context.curveTo(offsetX + 10 * x8, offsetY + 6 * y8, offsetX + 8 * x8, offsetY + 5 * y8);
                    } else {
                        context.curveTo(offsetX + 6 * x8, offsetY + 2 * y8, offsetX + 6 * x8, offsetY + 4 * y8);
                        context.curveTo(offsetX + 6 * x8, offsetY + 6 * y8, offsetX + 8 * x8, offsetY + 5 * y8);
                    }
                }
                context.lineTo(offsetX + 8 * x8, offsetY + 8 * y8);
                if (j != this.verticalPieces - 1) {
                    context.lineTo(offsetX + 5 * x8, offsetY + 8 * y8);
                    if (tileObj.down == 1) {
                        context.curveTo(offsetX + 6 * x8, offsetY + 10 * y8, offsetX + 4 * x8, offsetY + 10 * y8);
                        context.curveTo(offsetX + 2 * x8, offsetY + 10 * y8, offsetX + 3 * x8, offsetY + 8 * y8);
                    } else {
                        context.curveTo(offsetX + 6 * x8, offsetY + 6 * y8, offsetX + 4 * x8, offsetY + 6 * y8);
                        context.curveTo(offsetX + 2 * x8, offsetY + 6 * y8, offsetX + 3 * x8, offsetY + 8 * y8);
                    }
                }
                context.lineTo(offsetX, offsetY + 8 * y8);
                if (i != 0) {
                    context.lineTo(offsetX, offsetY + 5 * y8);
                    if (tileObj.left == 1) {
                        context.curveTo(offsetX - 2 * x8, offsetY + 6 * y8, offsetX - 2 * x8, offsetY + 4 * y8);
                        context.curveTo(offsetX - 2 * x8, offsetY + 2 * y8, offsetX, offsetY + 3 * y8);
                    } else {
                        context.curveTo(offsetX + 2 * x8, offsetY + 6 * y8, offsetX + 2 * x8, offsetY + 4 * y8);
                        context.curveTo(offsetX + 2 * x8, offsetY + 2 * y8, offsetX, offsetY + 3 * y8);
                    }
                }
                context.lineTo(offsetX, offsetY);
            },
            drawHint(shape, context) {
                let fill = new createjs.Graphics.Fill("#F0F0FF");
                let hint = new Shape();
                hint.mouseChildren = false;
                hint.mouseEnabled = false;
                hint.graphics = context.clone(true);
                hint.pos(this.puzzleX,this.puzzleY);
                hint.graphics._fill = fill;
                //hint.graphics._fill.style = null; //uncomment to transparent
                shape.hint = hint;
                hint.addTo(this.container,0);
            },
            dragHandler(e) {
                let mc = e.currentTarget;

                if (this.isRightPositionOfPuzzle(mc)) {
                    mc.x = this.puzzleX;
                    mc.y = this.puzzleY;
                    mc.noDrag();
                    mc.addTo(mc.parent,0);
                    mc.mouseChildren = false;
                    mc.mouseEnabled = false;
                    if (mc.hint) {
                        mc.hint.visible = false;
                    }
                    this.countPlacedPieces++;
                    this.soundInstance = this.$createjs.Sound.play("puzzleDrop");
                    this.soundInstance.volume = DEFAULT_VOLUME;
                    if(this.countPlacedPieces === this.totalPieces) {
                        this.puzzleDone();
                    }
                    this.stage.update();

                }
            },
            isRightPositionOfPuzzle (mc) {
                const xx = Math.round(mc.x);
                const yy = Math.round(mc.y);

                return xx < this.puzzleX + HELP_DISTANCE
                        && xx > this.puzzleX - HELP_DISTANCE
                        && yy < this.puzzleY + HELP_DISTANCE
                        && yy > this.puzzleY - HELP_DISTANCE;
            },
            puzzleDone() {
                this.isCorrect = true;
                if (this.isOlympiad) {
                    this.sendStat();
                    this.$emit('finish');
                    return;
                }
                if (this.isBattle) {
                    this.gameEnd = true;
                    this.stopTimer();
                    this.sendStat();
                    this.$emit('finish');
                    return;
                }
                this.puzzleComplete = true;
                this.gameEnd = true;
                this.soundInstance = this.$createjs.Sound.play("puzzleDone");
                this.soundInstance.volume = DEFAULT_VOLUME;
                this.sendStat();
            },
            whiteShapeClickHandler(e) {
                this.clickedPiece = e.target;
                if (!this.clickedPiece.coloredShape.visible) {
                    this.clickedPiece.noDrag();
                    this.showExample = true;
                }
            },
            colorizeShape(whiteShape) {
                if (whiteShape.coloredShape) {
                    whiteShape.coloredShape.pos(whiteShape.x, whiteShape.y);
                    whiteShape.animate({
                        props: {
                            visible: false,
                            alpha: 0
                        },
                        time: ANIMATION_TIME
                    });
                    whiteShape.coloredShape.visible = true;
                    whiteShape.coloredShape.animate({
                        props: {
                            alpha: 1
                        },
                        time: ANIMATION_TIME
                    })
                }
            },
            soundLoad() {
                this.loadedSound++;
                if (this.loadedSound === this.soundObjects.length) {
                    this.isLoading = false;
                    if (this.isFirstTime) {
                        this.isFirstTime = false;
                        this.$nextTick(() => {
                            this.start();
                            if ((this.isOlympiad || this.isBattle) && !this.timer) {
                                this.setTimer();
                            }
                        });
                    }
                }
            },
            registerSounds() {
                this.$createjs.Sound.removeAllSounds();
                this.$createjs.Sound.removeAllEventListeners();
                this.$createjs.Sound.addEventListener('fileload', this.soundLoad);
                this.$createjs.Sound.alternateExtensions = ["mp3"];
                this.$createjs.Sound.registerSounds(this.soundObjects);
            },
            showErrorMessage(err) {
                if (err.data) {
                    this.$toasted.error(err.data.message);
                    this.$router.push({ name: 'dashboard' });
                }
                err = (err.response && err.response.data) ? err.response.data : err;
                if (err && (err.status_code === 403 || err.status_code === 404)) {
                    this.$router.push({ name: 'dashboard' });
                    this.$toasted.error(err.message);
                }
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                paramsArray: state => state.trainer.paramsArray,
                puzzleGame: state => state.games.puzzle || state.trainer.game,
                homework: state => state.trainer.homework,
            }),
            isOlympiad () {
                return this.gameType === 'olympiad'
            },
            locale () {
                if (this.user && this.user.locale) {
                    return this.user.locale;
                }
                return 'ru';
            },
            getInnerGameType () {
                if (this.puzzleGame.games[0].parameters.default.withTime && this.puzzleGame.games[0].slug === 'Anzan') {
                    this.puzzleGame.games[0].slug = 'AnzanWithTime';
                }
                return this.puzzleGame.games[0].slug;
            },
            horizontalPieces () {
                return this.puzzleGame.difficult.x;
            },
            verticalPieces () {
                return this.puzzleGame.difficult.y;
            },
            totalPieces () {
                return this.horizontalPieces * this.verticalPieces;
            },
            pieceWidth () {
                return Math.round(this.puzzleImage.width / this.horizontalPieces);
            },
            pieceHeight () {
                return Math.round(this.puzzleImage.height / this.verticalPieces);
            },
            puzzleX () {
                return this.frame.width / 2 - this.puzzleImage.width / 2;
            },
            puzzleY () {
                return this.frame.height / 2 - this.puzzleImage.height / 2;
            },
            soundObjects() {
                let sounds = [];
                sounds.push(...this.trainerConfig.result);
                sounds.push(...this.trainerConfig.countdownSound);
                sounds.push(...this.trainerConfig.digitsSounds[this.locale]);
                sounds.push(...this.gamesConfig.puzzle.sounds);
                return sounds;
            },
            gameBox () {
                let gameBoxContainer = document.querySelector('.play-box');
                let width = 0;
                let height = 0;
                let documentElementWidth = document.documentElement.clientWidth;
                if (gameBoxContainer) {
                    width = gameBoxContainer.offsetWidth;
                    if (documentElementWidth >= 360) {
                        width -= SIDE_PADDING_SUMMARY;
                    }
                    if (documentElementWidth > 1200) {
                        width /= 1.5;
                    }
                    height = gameBoxContainer.offsetHeight - CANVAS_MARGIN;
                }
                return {width, height}
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "@/assets/sass/games/playbox.scss";

    .play-box {
        height: 100%;
    }
    .warning {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }
    .with-warning {
        display: table;
    }

    .puzzle-game-wrapper{
        display: flex;
        flex-direction: column-reverse;
        width: 100%;
        @include media($xl) {
            flex-direction: row;
        }
    }

    .puzzle-game-canvas-handler, .sound-loader {
        width: 100%;
        height: 100%;
        text-align: center
    }
    .puzzle-playbox {
        &_with-loader {
            display: table;
        }
        &__result-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            flex-grow: 1;
            flex-shrink: 1;
        }
        &__result-image {
            @media screen and (max-width: 575px) {
                max-height: 360px;
                max-width: 360px;
            }
            max-width: 450px;
            max-height: 450px;
            min-height: 360px;
            min-width: 360px;
            vertical-align: middle;
            border-radius: 12px;
        }
    }
    .puzzle-game-canvas-handler_block {
        display: block;
        padding-top: 3%;
    }
    .puzzle-playbox__result-buttons {
        display: flex;
        @media screen and (max-width: 575px) {
            flex-direction: column;
        }
    }
    .play-box__button {
        margin-left: 20px;
        @media screen and (max-width: 575px) {
            margin: 20px 0 0 0;
        }
    }
    .game-info__block {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        margin-bottom: 15px;
    }

    .puzzle-playbox__result-image {
        margin-bottom: 20px;
    }
</style>
